import Vue from 'vue';

Vue.component('vuetable-pump-test', () =>
    import(/* webpackChunkName: 'pump-test-index' */ './vuetable-pump-test.vue'),
);
